import api from '../../../utils/api'

import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import FormCost from './Form/FormCost'

function EditCost({ id, btCancelAction, handleOnSuccess }) {
    const [cost, setCost] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get(`/cost/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            setCost(response.data.cost)
        })
    }, [token, id])

    async function updateCost(cost) {
        let msgType = 'success'

        const data = await api.patch(`/cost/update/${cost._id}`, cost, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        cost._id && (
            <FormCost title="Editar Custo por Unidade" handleSubmit={updateCost} btnText="Salvar" btCancelAction={btCancelAction} costData={cost} />
        )
    )
}

export default EditCost
